import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { EmployeeService } from '../../services/employee-service';

@Component({
  selector: 'app-employee-registration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule
  ],
  templateUrl: './employee-registration.component.html',
  styleUrls: ['./employee-registration.component.css']
})
export class EmployeeRegistrationComponent implements OnInit {
  employeeForm!: FormGroup;
  isLoading = false;
  constructor(private fb: FormBuilder, private snackBar: MatSnackBar, private router: Router, private employeeService: EmployeeService) { }

  ngOnInit(): void {
    this.employeeForm = this.fb.group({
      employee_no: ['', Validators.required],
      registered_email: ['', [Validators.required, Validators.email]],
    });
  }

  submitEmployeeForm() {
    if (this.employeeForm.invalid) {
      this.employeeForm.markAllAsTouched();
      return;
    }
    if (this.isLoading) return;
    const payload = {
      jsonrpc: '2.0',
      method: 'call',
      params: {
        employee_no: this.employeeForm.value.employee_no,
        registered_email: this.employeeForm.value.registered_email
      }
    };
    this.isLoading = true;
    this.employeeService.signupEmployee(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res && res.result && res.result.status == 200) {
          this.router.navigate(['/registration-success', res.result.user_id,'employee']);
        }
        else {
          this.snackBar.open('Employee registration failed', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.snackBar.open('Employee registration failed', 'Close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
      }
    });
  }
}
